import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { CTAButton } from '../ui/CTAButton';
export function Hero() {
  return <section className="relative pt-16 pb-20 md:pt-24 md:pb-32 overflow-hidden bg-beige" data-id="element-45">
      {/* Decorative background elements */}
      <div className="absolute top-10 left-10 w-72 h-72 bg-gold/10 rounded-full blur-3xl" data-id="element-46"></div>
      <div className="absolute bottom-10 right-10 w-96 h-96 bg-navy/5 rounded-full blur-3xl" data-id="element-47"></div>
      <div className="absolute top-1/2 left-1/4 w-40 h-40 bg-gold/5 rounded-full blur-2xl" data-id="element-48"></div>

      {/* Subtle musical notes */}
      <div className="absolute top-20 right-[15%] text-navy/[0.04] text-8xl font-serif select-none pointer-events-none" data-id="element-49">
        ♪
      </div>
      <div className="absolute bottom-24 left-[10%] text-navy/[0.04] text-7xl font-serif select-none pointer-events-none" data-id="element-50">
        ♫
      </div>
      <div className="absolute top-1/3 right-[8%] text-navy/[0.04] text-6xl font-serif select-none pointer-events-none" data-id="element-51">
        ♩
      </div>

      <div className="container mx-auto px-4 max-w-6xl" data-id="element-52">
        <div className="flex flex-col items-center text-center" data-id="element-53">
          <FadeIn data-id="element-54">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-navy mb-6 leading-tight max-w-4xl mx-auto" data-id="element-55">
              ¡Tocá tu primera canción{' '}
              <span className="text-gold underline decoration-gold/50 underline-offset-4" data-id="element-56">
                en 48h
              </span>
              !
            </h1>
          </FadeIn>

          <FadeIn delay={0.3} className="w-full max-w-sm mx-auto mb-6" data-id="element-57">
            <div className="relative" data-id="element-58">
              <div className="absolute inset-0 bg-gold/20 blur-3xl rounded-full transform scale-90" data-id="element-59"></div>
              <img src="https://cdn.magicpatterns.com/uploads/cW96ahCdMJqK6kMQRFBrK9/Untitled_design.png" alt="Piano Fácil PRO - Libro y materiales" className="relative z-10 w-[70%] h-auto drop-shadow-2xl mx-auto" data-id="element-60" />
            </div>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-61">
            <p className="text-xl md:text-2xl text-navy/80 mb-3 max-w-2xl mx-auto font-medium" data-id="element-62">
              Aprendé a tocar piano sin partituras ni teoría
            </p>
            <p className="text-lg md:text-xl text-navy/60 italic mb-10 max-w-2xl mx-auto" data-id="element-63">
              Aunque siempre pensaste que era tarde para aprender…
            </p>
          </FadeIn>

          <FadeIn delay={0.6} className="flex flex-col items-center w-full max-w-md mx-auto" data-id="element-64">
            <CTAButton fullWidth className="mb-4" data-id="element-65">
              QUIERO TOCAR MI PRIMERA CANCIÓN
            </CTAButton>
            <p className="text-sm font-medium text-navy/60 flex items-center gap-2" data-id="element-66">
              <span className="w-2 h-2 rounded-full bg-green-500" data-id="element-67"></span>
              Acceso inmediato – empezás hoy mismo
            </p>
          </FadeIn>
        </div>
      </div>
    </section>;
}